exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-check-input {\n  width: 24px !important;\n  height: 24px !important;\n  cursor: pointer;\n  margin-left: 0 !important; }\n\n.preview-image-container {\n  height: 225px;\n  width: 200px;\n  margin: 0 auto;\n  overflow: hidden;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n  border-radius: 0.25rem; }\n\n.preview-image {\n  max-width: 170px;\n  max-height: 210px;\n  -o-object-fit: contain;\n     object-fit: contain;\n  width: auto;\n  height: auto; }\n\n.form-control {\n  padding: 0.25rem 0.5rem; }\n\n.btn {\n  padding: 0.375rem 0.75rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/rfid-reprint-modal/rfid-reprint-modal.component.scss
// module id = ../../../../../src/app/shared/modals/rfid-reprint-modal/rfid-reprint-modal.component.scss
// module chunks = main